"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostcodeEpcWrapper$ = exports.PostcodeEpcWrapper$outboundSchema = exports.PostcodeEpcWrapper$inboundSchema = void 0;
exports.postcodeEpcWrapperToJSON = postcodeEpcWrapperToJSON;
exports.postcodeEpcWrapperFromJSON = postcodeEpcWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const postcodeepcattributes_js_1 = require("./postcodeepcattributes.js");
/** @internal */
exports.PostcodeEpcWrapper$inboundSchema = z.object({
    attributes: postcodeepcattributes_js_1.PostcodeEpcAttributes$inboundSchema,
    id: z.string(),
});
/** @internal */
exports.PostcodeEpcWrapper$outboundSchema = z.object({
    attributes: postcodeepcattributes_js_1.PostcodeEpcAttributes$outboundSchema,
    id: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodeEpcWrapper$;
(function (PostcodeEpcWrapper$) {
    /** @deprecated use `PostcodeEpcWrapper$inboundSchema` instead. */
    PostcodeEpcWrapper$.inboundSchema = exports.PostcodeEpcWrapper$inboundSchema;
    /** @deprecated use `PostcodeEpcWrapper$outboundSchema` instead. */
    PostcodeEpcWrapper$.outboundSchema = exports.PostcodeEpcWrapper$outboundSchema;
})(PostcodeEpcWrapper$ || (exports.PostcodeEpcWrapper$ = PostcodeEpcWrapper$ = {}));
function postcodeEpcWrapperToJSON(postcodeEpcWrapper) {
    return JSON.stringify(exports.PostcodeEpcWrapper$outboundSchema.parse(postcodeEpcWrapper));
}
function postcodeEpcWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodeEpcWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodeEpcWrapper' from JSON`);
}
//# sourceMappingURL=postcodeepcwrapper.js.map